import { applyMiddleware, createStore, compose, Middleware, Store } from "redux";
import { thunk } from "redux-thunk";
import reduxFreeze from "redux-freeze";
import environment from "environment";
import rootReducer from "./rootReducer";
import IStore from "../models/IStore";
import errorToastMiddleware from "../middlewares/errorToastMiddleware";

// Use Redux DevTools Extension if available, otherwise use regular compose
const composeEnhancers = 
  (typeof window !== 'undefined' && 
   (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || 
  compose;

const rootStore = (initialState: Partial<IStore>): Store<IStore> => {
  const middleware: Middleware[] = [
    environment.isDevelopment ? reduxFreeze : null!,
    thunk,
    errorToastMiddleware(),
  ].filter(Boolean);

  const store: Store<IStore> = createStore(
    rootReducer(),
    initialState as any,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  return store;
};

export default rootStore;
